<template>
<div>
  <div class="container">
    <margin-title :title="title" :subtitle="subtitle">
      <spinner size="medium" line-fg-color="#44c7f0" class="spinner"
        v-if="state === 'loading'" />
    </margin-title>
  </div>
</div>
</template>

<script>
import Spinner from 'vue-simple-spinner'
import Accounts from '@/api/accounts'
import MarginTitle from '@/components/margin-title'

export default {
  components: { Spinner, MarginTitle },
  data () {
    return {
      state: 'loading',
      error: null
    }
  },
  computed: {
    title () {
      switch (this.state) {
        case 'loading': return 'Verifying your email address'
        case 'success': return 'Email address verified'
        case 'error': return 'Something went wrong'
        default: return ''
      }
    },
    subtitle () {
      switch (this.state) {
        case 'loading': return 'Please wait'
        case 'success': return 'Thanks for joining'
        case 'error': return this.error
        default: return ''
      }
    }
  },
  async mounted () {
    const email = this.$route.query.email
    const token = this.$route.query.token
    try {
      await Accounts.verify({ email, token })
      this.state = 'success'
      this.$ga.event('Account', 'Email Verified')
    } catch (error) {
      this.state = 'error'
      this.error = error.response.statusText
    }
  }
}
</script>

<style lang="scss" scoped>
.hero .navbar {
  background-color: #111111;
  margin-bottom: 0px;
}
.spinner {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/verify.vue